

export const theme = {
    colors: {
        main: '#ebb600', // dark
        secondary: '#00626d',
        white: '#ffffff',
        grey0: '#f2f2f2',  // e6e6e6
        grey1: '#cccccc', // c0c0c0
        grey2: '#a6a6a6', // 999999
        grey3: '#808080', // 8d8d8d // 737373
        grey4: '#5a5a5a', // 666666
        grey5: '#333333', // 404040
        grey6: '#0d0d0d', // 1a1a1a 
        ruRed: '#cc0033',
        ruBlack: '#000',
        ruGrey: '#5f6a72',
        ruLime: '#9ea900',
        ruYellow: '#ebb600',
        ruOrange: '#e76f00',
        ruBlue: '#007fac',
        ruBeige: '#dfd2b3',
        ruTeal: '#00626d',
        ruBrown: '#703221',
        ruGreyBeige: '#c1bbab',
        pdeBlue: '#146b91',
        pdeGreen: '#398257',
        pdeOrange: '#e2711f',
        errorRed: '#c34d1e',
        greenCell: '#d4e3cd',
        redCell: '#fee0d1',
        yellowCell: '#fff0c8',
        greenGlow: '#34eb46',
        redGlow: '#f51616',
        yellowGlow: '#fae820'
            },
    fontStyles: {
      
      size: '18px',
    },
    mobile: "768px",
    siteWidth: "1366px",
    boxShadow: '0 0 4px rgba(0,0,0,.16)',
    borderRadius: "1rem",
  };

  